import { getRequest, postRequest } from "../connection/network";

const userApi = {
  users: "users",
  export: "users/export",
  today: "users/export/today",
};

export const createUser = async ({ user }) => {
  try {
    const {
      data: { content },
    } = await postRequest({
      endPoint: userApi.users,
      body: {
        name: user?.name,
        email: user?.email,
        mobile: user?.mobile,
        routine: user?.routine,
      },
    });

    return content;
  } catch (e) {
      console.error("createUser error:", e);

    // Fallback in case destructuring fails
    const error = e?.response?.data?.error || "Unexpected error occurred.";
    return { error };
  }
};

export const downloadExcel = async () => {
  try {
    const {
      data: { content },
    } = await getRequest({
      endPoint: userApi.export,
    });

    return content;
  } catch (e) {
    const { error } = e?.response?.data;
    return { error };
  }
};

export const downloadExcelToday = async () => {
  try {
    const {
      data: { content },
    } = await getRequest({
      endPoint: userApi.today,
    });

    return content;
  } catch (e) {
    const { error } = e?.response?.data;
    return { error };
  }
};
